import { EXTERNAL_SERVICE_NAME, OUTAGE_INCIDENT_STATUS } from "@Shared/@Types/status-page/types";
export const GLOBAL_MAINTENANCE_IN_PROGRESS = "GLOBAL_MAINTENANCE_IN_PROGRESS";
export const GLOBAL_MAINTENANCE_MESSAGE = "GLOBAL_MAINTENANCE_MESSAGE";
const getters = {
  [GLOBAL_MAINTENANCE_IN_PROGRESS]: state => {
    const incident = state.externalServicesIncidents.byId[EXTERNAL_SERVICE_NAME.GLOBAL];
    return (incident == null ? void 0 : incident.status) === OUTAGE_INCIDENT_STATUS.MAINTENANCE;
  },
  [GLOBAL_MAINTENANCE_MESSAGE]: state => {
    const incident = state.externalServicesIncidents.byId[EXTERNAL_SERVICE_NAME.GLOBAL];
    return incident == null ? void 0 : incident.description;
  }
};
export default getters;